import type { FC, ReactNode } from 'react'

import { BookingButton } from '@/components/generals/button-link'
import { FernMark } from '@/components/generals/fern-mark'

interface CtaBandProps {
    title?: ReactNode
    description?: ReactNode
    buttonLabel?: string
}

export const CtaBand: FC<CtaBandProps> = ({
    title = "You Don't Have to Hold It All Alone",
    description = "Book a free 15-minute call, and see what it feels like to have someone in your corner.",
    buttonLabel = "Book a Free 15-Minute Consult"
}): ReactNode => {
    return (
        <section id='book-a-consult' className='px-5 py-20 sm:px-8 sm:py-28'>
            <div className='reveal relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-sand px-6 py-16 text-center sm:px-12 sm:py-20'>
                <FernMark className='pointer-events-none absolute -bottom-16 -left-10 h-72 w-auto text-plum/[0.07]' />
                <FernMark className='pointer-events-none absolute -right-8 -top-12 h-64 w-auto -scale-x-100 text-honey/40' />

                <div className='relative mx-auto max-w-2xl'>
                    <h2 className='font-heading text-[2.1rem] leading-tight text-plum text-balance sm:text-5xl'>
                        {title}
                    </h2>

                    <p className='mt-5 text-lg leading-relaxed text-espresso-soft sm:text-xl'>
                        {description}
                    </p>

                    <BookingButton size='lg' className='mt-9'>
                        {buttonLabel}
                    </BookingButton>
                </div>
            </div>
        </section>
    )
}
